// src/services/activityService.js
import Swal from 'sweetalert2';
import axios from 'axios';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const getMaquinarias = async (id) => {
    const response = await api.get(`/actividades-publicas/maquinarias`);
    return response.data;
};

export const procesoByMaquinaria = async (id) => {
  const response = await api.get(`/actividades-publicas/maquinarias/${id}/procesos`);
  return response.data;
};

export const materialesByProceso = async (id, maquinariaId) => {
  const response = await api.get(`/actividades-publicas/maquinarias/${maquinariaId}/procesos/${id}/materiales`);
  return response.data;
};

export const submitActivity = async (data) => {
  const response = await api.post('/actividades-publicas/', data);
  return response.data;
};

export const submitActivityPeso = async (data) => {
  return new Promise((resolve, reject) => {
    MySwal.fire({
      title: 'Formulario de Peso y Horas de Parada',
      html:
        '<input id="swal-input1" class="swal2-input" type="number" step="0.01" placeholder="Peso">' +
        '<input id="swal-input2" class="swal2-input" type="number" step="0.01" placeholder="Horas de Parada">',
      focusConfirm: false,
      preConfirm: () => {
        const weight = document.getElementById('swal-input1').value;
        const stopHours = document.getElementById('swal-input2').value;
        return { weight, stopHours };
      },
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        data.peso = result.value.weight == "" ? null : result.value.weight;
        data.horasParada = result.value.stopHours == "" ? null : result.value.stopHours;
        let response = await submitActivity(data);
        resolve(await response !== null)
      }
    }).catch((error) => {
      console.error("Failed to submit activity", error);
      reject(false)
    });
  });
};

export const submitActivityClose = async (data) => {
  const response = await api.post('/actividades-publicas/close', data);
  return response.data;
};

export const submitActivityClosePeso = async (data) => {
  return new Promise((resolve, reject) => {
    MySwal.fire({
      title: 'Formulario de Peso y Horas de Parada',
      html:
        '<input id="swal-input1" class="swal2-input" type="number" step="0.01" placeholder="Peso">' +
        '<input id="swal-input2" class="swal2-input" type="number" step="0.01" placeholder="Horas de Parada">',
      focusConfirm: false,
      preConfirm: () => {
        const weight = document.getElementById('swal-input1').value;
        const stopHours = document.getElementById('swal-input2').value;
        return { weight, stopHours };
      },
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        data.peso = result.value.weight == "" ? null : result.value.weight;
        data.horasParada = result.value.stopHours == "" ? null : result.value.stopHours;
        let response = await submitActivityClose(data);
        resolve(await response !== null)
      }
    }).catch((error) => {
      console.error("Failed to submit activity", error);
      reject(false);
    });
  });
};